import { FC, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';

import { useTheme } from 'context/theme';
import { StyledComponent } from 'types';

export const LabelValueGroupTestIds = {
  container: 'label-value-group-container'
};

export type LabelValueGroupProps = {
  label: ReactNode;
  value?: ReactNode;
} & StyledComponent &
  PropsWithChildren;

export const LabelValueGroup: FC<LabelValueGroupProps> = ({ label, value, className = '', children }) => {
  const { isDark } = useTheme();

  return (
    <div
      data-testid={LabelValueGroupTestIds.container}
      className={classNames('px-3 my-3 border-start d-flex flex-column justify-content-between', className, {
        'border-light20': isDark
      })}
    >
      <span className={`test-label ${isDark ? 'text-light60' : 'text-secondary'} label mb-1`}>
        {label}
        <span className='invisible'>:&nbsp;</span>
      </span>
      <span className={`test-value ${isDark ? 'text-light' : 'text-primary'} riforma-regular`}>
        {value ? value : children}
      </span>
    </div>
  );
};
